var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSmockThumbDownOutline18N(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.146,
    height: 18.5,
    viewBox: "0 0 19.146 18.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#ff13dc;opacity:0;}.b{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(1)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 18,
    height: 18
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M19.965,11.624l-2.473-7a2.878,2.878,0,0,0-2.561-1.5H5.966A.621.621,0,0,0,5.345,2.5H1.621A.621.621,0,0,0,1,3.121v9.931a.621.621,0,0,0,.621.621H5.345a.621.621,0,0,0,.621-.621v-.3c1.58.729,4.455,3,4.742,5.78A2.065,2.065,0,0,0,12.744,20.5a2.361,2.361,0,0,0,1.969-2.444,13.33,13.33,0,0,0-.5-3.774l4.066.006a1.862,1.862,0,0,0,1.682-2.664Zm-1.68,1.428h-5.9a9.342,9.342,0,0,1,1.084,5c-.032.745-.349,1.2-.728,1.2a.853.853,0,0,1-.8-.745c-.3-3.645-4.2-6.359-5.983-7.076V4.362l9.3-.012a1.143,1.143,0,0,1,1.081.765l2.493,7.049a.621.621,0,0,1-.56.889Z",
    transform: "translate(-2 -2)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmockThumbDownOutline18N);
export default __webpack_public_path__ + "static/media/Smock_ThumbDownOutline_18_N.2ba96d31b3cd7f0dfd39cef088e0692b.svg";
export { ForwardRef as ReactComponent };